import * as React from 'react';

function SvgContractRecordLandlord(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87 93" {...props}>
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M9.36 76.675c17.693 1.563 37.192 7.34 57.71 15.463C69.303 66.625 75.5 42.71 86.231 20.63L28.521 5.166a208.652 208.652 0 00-19.16 71.509z"
            fill="#E7E7E7"
          />
          <path
            d="M7.66 72.644c17.692 1.563 37.191 7.34 57.71 15.463 2.232-25.513 8.43-49.428 19.16-71.509L26.82 1.135A208.652 208.652 0 007.66 72.644z"
            stroke="#E5E5E5"
            fill="#FFF"
          />
          <path fill="#3B3B3B" d="M63.444 13.634L43.37 8.255l1.765-6.587 20.074 5.38z" />
          <path
            fill="#38B2A6"
            d="M31.332 22.402l35.582 9.534-1.291 4.818L30.04 27.22zM28.65 32.409l35.582 9.534-1.29 4.818-35.582-9.534z"
          />
        </g>
        <g fillRule="nonzero">
          <path
            d="M6.413 79.849c15.793-2.772 34.146-2.29 53.937 0-4.015-22.77-4.199-45.072 0-66.834H6.413a188.366 188.366 0 000 66.834z"
            fill="#E7E7E7"
          />
          <path
            d="M3.988 76.73c15.793-2.77 34.146-2.289 53.937 0-4.015-22.769-4.199-45.071 0-66.833H3.988a188.366 188.366 0 000 66.834z"
            stroke="#E5E5E5"
            fill="#FFF"
          />
          <path fill="#3B3B3B" d="M38.844 12.24H20.082V6.084h18.762z" />
          <path
            fill="#38B2A6"
            d="M12.891 27.388h33.256v4.503H12.891zm0 9.353h33.256v4.503H12.891z"
          />
        </g>
        <g transform="translate(42 55)">
          <circle fill="#E2F4F2" cx={19} cy={19} r={19} />
          <path
            d="M12.8 17.75c-.483-.885-1.567-1.197-2.42-.683-.839.504-1.126 1.607-.652 2.477l3.817 7.023c.313.579.904.933 1.538.933a1.7 1.7 0 00.889-.25c.118-.073.225-.154.313-.24l12.71-13.397a1.874 1.874 0 00-.002-2.562 1.71 1.71 0 00-2.509-.006L15.467 22.658 12.8 17.75z"
            fill="#38B2A6"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgContractRecordLandlord;
